import React from 'react';
import PropertyDetails from '../PropertyDetails';
import Price from 'components/cards/new-layout/components/Price';
import { SpacingBlock } from 'components/spacing-block';
import AgentTags from 'components/cards/new-layout/components/AgentTags';
import { useLocale } from 'locale';
import { getBuildingClassKey } from 'utils/entities';
import { useUniversalCardAddress } from 'components/cards/listing/UniversalCard/utils';
import { CardInnerSeparator, PropertyPrimaryLine, PropertyPrimaryInfo } from '../styled';
import { UniversalCardExtraProps } from 'components/cards/new-layout/types';
import { BulletinUniversalCardProps } from 'components/cards/types';
import InfoIcon from 'assets/svg/light-info.svg';
import { TextLabel } from 'ds/components/typography';
import { YieldRoot } from 'components/cards/new-layout/styled';
import { formatInvestorsYield } from 'utils/investors';
import { connect } from 'react-redux';
import { routeNameSelector } from 'store/state/selectors/router';
import { Route } from 'config/routes';
import { State } from 'store/state';

const BulletinCard: React.FC<BulletinUniversalCardProps & UniversalCardExtraProps> = (props) => {
  const {
    id,
    isAgent,
    isExclusive,
    madadSearchResult,
    price,
    eventsHistory,
    bedsCount,
    size,
    floor,
    buildingClass,
    streetName,
    streetNumber,
    neighbourhood,
    unitNumber,
    city,
    resolutionPreferences,
    isSearchInWholeCountry,
    investorsData,
    openYieldTagModal,
    routeName,
  } = props;

  const localeProps = useLocale();
  const { t, formatArea } = localeProps;
  const isInvestorMarketplace = routeName === Route.InvestorsSearchPage;

  const propertyTypeLabel = !!buildingClass ? (
    t('unitPage.buildingClass', { buildingClass: getBuildingClassKey(buildingClass), isCommercial: false })
  ) : null;

  const primaryAddress = useUniversalCardAddress(
    streetName,
    streetNumber,
    neighbourhood,
    unitNumber,
    city,
    resolutionPreferences,
    isSearchInWholeCountry
  );

  const secondaryLine = [ propertyTypeLabel, primaryAddress ].filter(Boolean).join(', ');

  const onYieldClick = React.useCallback((e: React.SyntheticEvent) => {
    e.preventDefault();
    e.stopPropagation();
    if (openYieldTagModal) {
      openYieldTagModal(id);
    }
  }, [ openYieldTagModal ]);

  return (
    <>
      <PropertyPrimaryInfo>
        <PropertyPrimaryLine data-auto="property-address">
          {secondaryLine}
        </PropertyPrimaryLine>
        {isAgent ? (
          <SpacingBlock mTop={0.5}>
            <AgentTags isExclusive={isExclusive} madadSearchResult={madadSearchResult} />
          </SpacingBlock>
        ) : null}
      </PropertyPrimaryInfo>
      <CardInnerSeparator />
      <PropertyDetails
        rooms={bedsCount}
        floor={floor}
        area={formatArea(size, false)}
      />
      <CardInnerSeparator />
      <div>
        <Price price={price} eventsHistory={eventsHistory} direction="up" />
        {isInvestorMarketplace && (
          <YieldRoot active={Boolean(investorsData && investorsData.yield)} onClick={onYieldClick} data-auto="yield-info">
            <TextLabel small weight="normal">
              {investorsData && investorsData.yield ? t('widget.search.card.yield', { yield: formatInvestorsYield(investorsData.yield) }) : t('widget.card.yield.empty')}
            </TextLabel>
            <InfoIcon />
          </YieldRoot>
        )}
      </div>
    </>
  );
};

const mapStateToProps = (state: State) => ({
  routeName: routeNameSelector(state),
});

export default connect(mapStateToProps)(BulletinCard);
